export default {
    methods: {
        isBlockedOrDeleted(elem) {
            return this.isBlocked(elem) || this.isDeleted(elem);
        },
        isBlocked(item) {
            return item.status && item.status == 'blocked';
        },
        isDeleted(item) {
            return item.status && item.status == 'deleted';
        },
        statusClass(elem) {
            let classes = '';
            if (elem.status) {
                this.isBlocked(elem) || this.isDeleted(elem)
                    ? (classes += 'avatar-name-disabled')
                    : '';
                this.isDeleted(elem) ? (classes += ' strike') : '';
            }
            return classes;
        },
        avatarColor(name) {
            if (name) {
                const avatarColors = ['green', 'yellow', 'pink'];
                const color = avatarColors[name.replace(' ', '').length % avatarColors.length];
                return `bg-component-background-avatar-random-${color}`;
            }
            
        },
    },
    computed: {
        avatarSize() {
            if (this.size && this.size != '') {
                return 'avatar-' + this.size;
            }
            return false;
        },
    },
};
